module.exports = __webpack_public_path__ + "img/home-ind-card.13018f1d.jpg";